import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { cx } from './cx';

function buttonClass({ variant, size, block, className }) {
  return cx('btn', variant && variant !== 'secondary' && `btn--${variant}`, size && `btn--${size}`, block && 'btn--block', className);
}

function ButtonContent({ loading, icon: Icon, trail: Trail, children }) {
  return (
    <>
      {loading ? <span className="spinner" aria-hidden="true" /> : Icon ? <Icon className="btn__icon" aria-hidden="true" /> : null}
      {children}
      {Trail && <Trail className="btn__icon btn__trail" aria-hidden="true" />}
    </>
  );
}

export const Button = forwardRef(function Button(
  { variant = 'secondary', size, block, loading = false, icon, trail, children, className, type = 'button', disabled, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={buttonClass({ variant, size, block, className })}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      <ButtonContent loading={loading} icon={icon} trail={trail}>
        {children}
      </ButtonContent>
    </button>
  );
});

export function ButtonLink({ to, variant = 'secondary', size, block, icon, trail, children, className, ...rest }) {
  return (
    <Link to={to} className={buttonClass({ variant, size, block, className })} {...rest}>
      <ButtonContent icon={icon} trail={trail}>
        {children}
      </ButtonContent>
    </Link>
  );
}

export const IconButton = forwardRef(function IconButton({ label, icon: Icon, size, className, type = 'button', ...rest }, ref) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx('icon-btn', size === 'sm' && 'icon-btn--sm', className)}
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon aria-hidden="true" />
    </button>
  );
});
